function TechBadge({ techName }) {
  return <span className="tech-ticker__item">{techName}</span>;
}

export default TechBadge;
